const jsonldForArticles = (data) => {
	// Предварительное формирование данных
	// const url = `${process.env.BASE_URL}/sp/${data.issue.slug}/article/${data.slug}/`;
	const url = `${process.env.baseFrontendURL}${data.taxonomy_type_slug}/${data.slug}/`;
	const image = data.listing_cover_image_default.src || data.issue.top_cover_image_url_default;
	const logo = 'https://www.skolkovo.ru/public/images/stories/logo/logo_skolkovo_rus_forblack.png';
	const logoWidth = 160;
	const logoHeight = 105;
	const date = `${data.date}+3:00`;

	// Основные данные разметки
	let jsonldData = {
		'@context': 'http://schema.org',
		'@type': 'Article',
		mainEntityOfPage: {
			'@type': 'WebPage',
			'@id': url,
		},
		headline: data.meta_title || data.title,
		image,
		datePublished: date,
		dateModified: data.updated_at,
		publisher: {
			'@type': 'Organization',
			name: 'Бизнес-школа СКОЛКОВО',
			url: 'https://www.skolkovo.ru',
			logo: {
				'@type': 'ImageObject',
				url: logo,
				width: logoWidth,
				height: logoHeight,
			},
		},
		description: data.intro,
	};

	// Добавление aвторов
	if (data.authors.length > 0) {
		const author = [];
		data.authors.forEach((pers) => {
			author.push({
				'@type': 'Person',
				name: pers.title,
			});
		});

		jsonldData = { ...jsonldData, author };
	}

	// Profit
	return jsonldData;
};

export default jsonldForArticles;
